export const SUPPORTED_RESUME_THEMES = Object.freeze([
  "default",
  "minimal",
  "modern",
  "elegant",
]);

export const normalizeResumeTheme = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  return SUPPORTED_RESUME_THEMES.includes(normalized) ? normalized : "default";
};
